/**
 * Used to get the compiler to ensure that we've covered all possible
 * values for the given argument.
 */
export function exhaustiveCheck(x: never): never {
  throw new Error(`Unreached: Received unexpected input ${x}`);
}
